import React, { useState, useEffect } from 'react';
import '../../../assets/css/popup/NoticePopup01.css';

const NoticePopup01 = () => {

    const [isVisible, setIsVisible] = useState(false);
    const [dontShowAgain, setDontShowAgain] = useState(false);

    useEffect(() => {
        const hideUntil = localStorage.getItem('hideNoticeUntil');

        if (hideUntil) {
            const hideDate = new Date(hideUntil);
            const now = new Date();

            if (now < hideDate) {
                setIsVisible(false);
                return;
            }
        }

        setIsVisible(true);
    }, []);

    const handleClose = () => {
        if (dontShowAgain) {
            const hideUntil = new Date();
            hideUntil.setDate(hideUntil.getDate() + 7);
            localStorage.setItem('hideNoticeUntil', hideUntil.toISOString());
        }
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="notice-overlay">
            <div className="notice-modal">
                <div className="notice-header">
                    <div className="notice-icon">📢</div>
                    <h2 className="notice-title">안내사항</h2>
                    <button className="notice-close" onClick={handleClose}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                    </button>
                </div>

                <div className="notice-body">
                    <h3 className="notice-subtitle">전자증명서 발급 가입 고객님께</h3>

                    <p className="notice-intro">
                        시험기관(KCL, KTR, KTC 등)을 통해 전자문서지갑으로 시험성적서를 신청하신 경우,<br />
                        다음 사항을 확인해 주시기 바랍니다.
                    </p>

                    <div className="notice-info-box">
                        <div className="info-item">
                            <span className="info-number">1</span>
                            <p>시험의뢰 시 기재한 <strong>의뢰담당자 정보</strong>와
                                <strong> 회원가입 정보</strong>가 일치해야 문서를 확인하실 수 있습니다.</p>
                        </div>

                        <div className="info-item">
                            <span className="info-number">2</span>
                            <p>가입 후 최초 로그인 시 정보확인 및 처리에
                                <strong className="highlight"> 최대 3시간</strong>이 소요될 수 있습니다.</p>
                        </div>

                        <div className="info-item">
                            <span className="info-number">3</span>
                            <p>3시간 이후에 문서 목록을 확인해주시기 바랍니다.</p>
                        </div>
                    </div>
                </div>

                <div className="notice-footer">
                    <label className="notice-checkbox">
                        <input
                            type="checkbox"
                            checked={dontShowAgain}
                            onChange={(e) => setDontShowAgain(e.target.checked)}
                        />
                        <span>일주일 동안 보지 않기</span>
                    </label>
                    <button className="notice-confirm" onClick={handleClose}>
                        확인
                    </button>
                </div>
            </div>
        </div>
    );
};


export default NoticePopup01;